<template>
  <div class="page-container">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card class="user-card">
          <div class="user-info-panel">
            <div class="avatar-area">
              <el-avatar :size="90" :src="userInfo.avatar || defaultAvatar" class="main-avatar" />
              <el-button size="mini" type="text" icon="el-icon-camera" @click="showAvatarDialog = true">修改头像</el-button>
            </div>
            <h3 class="user-name">{{ userInfo.nickname || userInfo.username }}</h3>
            <p class="user-email">{{ userInfo.email || '未设置邮箱' }}</p>
            <el-divider />
            <div class="user-detail">
              <div class="detail-item">
                <i class="el-icon-user" />
                <span class="label">账号：</span>
                <span>{{ userInfo.username }}</span>
              </div>
              <div class="detail-item">
                <i class="el-icon-s-custom" />
                <span class="label">角色：</span>
                <span>{{ roles.join('、') || '暂无' }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="16">
        <el-card>
          <el-tabs v-model="activeTab">
            <el-tab-pane label="基本信息" name="info">
              <el-form ref="infoForm" :model="infoForm" :rules="infoRules" label-width="80px" style="max-width: 420px; margin-top: 20px">
                <el-form-item label="昵称" prop="nickname">
                  <el-input v-model="infoForm.nickname" placeholder="请输入昵称" />
                </el-form-item>
                <el-form-item label="邮箱">
                  <el-input v-model="infoForm.email" placeholder="请输入邮箱" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" :loading="infoLoading" @click="handleInfoSubmit">保存修改</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>

            <el-tab-pane label="修改密码" name="password">
              <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="100px" style="max-width: 420px; margin-top: 20px">
                <el-form-item label="原密码" prop="oldPassword">
                  <el-input v-model="pwdForm.oldPassword" type="password" placeholder="请输入原密码" show-password />
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                  <el-input v-model="pwdForm.newPassword" type="password" placeholder="请输入新密码（至少6位）" show-password />
                </el-form-item>
                <el-form-item label="确认新密码" prop="confirmPassword">
                  <el-input v-model="pwdForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" :loading="pwdLoading" @click="handlePwdSubmit">修改密码</el-button>
                  <el-button size="mini" @click="resetPwdForm">重置</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="上传并裁剪头像" :visible.sync="showAvatarDialog" width="760px" @closed="resetCropDialog">
      <div class="cropper-wrap">
        <div class="left">
          <el-upload
            class="avatar-uploader"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleChooseFile"
            accept="image/jpeg,image/png,image/webp"
          >
            <el-button type="primary" size="mini" plain icon="el-icon-upload2">选择本地图片</el-button>
          </el-upload>
          <div v-if="cropImage" class="cropper-box">
            <vue-cropper
              ref="cropper"
              :src="cropImage"
              :view-mode="1"
              :drag-mode="'move'"
              :auto-crop-area="1"
              :aspect-ratio="1"
              :background="true"
              :guides="true"
              :responsive="true"
            />
          </div>
          <p v-else class="tip">请选择本地图片后进行裁剪</p>
        </div>
        <div class="right">
          <p class="preview-title">预览</p>
          <el-avatar :size="120" :src="previewImage || userInfo.avatar || defaultAvatar" />
          <div class="tool-btns">
            <el-button size="mini" @click="zoom(0.1)">放大</el-button>
            <el-button size="mini" @click="zoom(-0.1)">缩小</el-button>
            <el-button size="mini" @click="rotate(45)">旋转</el-button>
            <el-button size="mini" @click="resetCropper">重置</el-button>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="showAvatarDialog = false">取消</el-button>
        <el-button type="primary" size="mini" :loading="avatarLoading" @click="handleUploadAvatar">裁剪并上传</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { updateProfile, changePassword, uploadAvatar } from '@/api/profile'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  name: 'Profile',
  components: { VueCropper },
  data() {
    return {
      defaultAvatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
      activeTab: 'info',
      infoForm: { nickname: '', email: '' },
      infoRules: { nickname: [{ required: true, message: '昵称不能为空', trigger: 'blur' }] },
      infoLoading: false,
      pwdForm: { oldPassword: '', newPassword: '', confirmPassword: '' },
      pwdRules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { min: 6, message: '密码至少6位', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.pwdForm.newPassword) callback(new Error('两次密码不一致'))
              else callback()
            },
            trigger: 'blur'
          }
        ]
      },
      pwdLoading: false,
      showAvatarDialog: false,
      avatarLoading: false,
      cropImage: '',
      previewImage: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'roles'])
  },
  created() {
    this.infoForm.nickname = this.userInfo.nickname || ''
    this.infoForm.email = this.userInfo.email || ''
  },
  methods: {
    async handleInfoSubmit() {
      const valid = await this.$refs.infoForm.validate().catch(() => false)
      if (!valid) return
      this.infoLoading = true
      try {
        const res = await updateProfile(this.infoForm)
        this.$store.commit('user/SET_USER_INFO', { ...this.userInfo, ...res.data })
        this.$message.success('信息更新成功')
      } finally {
        this.infoLoading = false
      }
    },
    async handlePwdSubmit() {
      const valid = await this.$refs.pwdForm.validate().catch(() => false)
      if (!valid) return
      this.pwdLoading = true
      try {
        await changePassword(this.pwdForm)
        this.$message.success('密码修改成功，请重新登录')
        setTimeout(() => {
          this.$store.dispatch('user/logout').then(() => {
            this.$router.push('/login')
          })
        }, 1500)
      } finally {
        this.pwdLoading = false
      }
    },
    handleChooseFile(file) {
      const raw = file.raw
      if (!raw) return
      if (!/^image\/(jpeg|png|webp)$/.test(raw.type)) {
        this.$message.error('仅支持 jpg/png/webp 图片')
        return
      }
      const reader = new FileReader()
      reader.onload = () => {
        this.cropImage = reader.result
        this.previewImage = reader.result
      }
      reader.readAsDataURL(raw)
    },
    zoom(delta) {
      this.$refs.cropper && this.$refs.cropper.relativeZoom(delta)
    },
    rotate(deg) {
      this.$refs.cropper && this.$refs.cropper.rotate(deg)
    },
    resetCropper() {
      this.$refs.cropper && this.$refs.cropper.reset()
    },
    resetCropDialog() {
      this.cropImage = ''
      this.previewImage = ''
      this.avatarLoading = false
    },
    async handleUploadAvatar() {
      if (!this.$refs.cropper || !this.cropImage) {
        this.$message.warning('请先选择并裁剪图片')
        return
      }

      const canvas = this.$refs.cropper.getCroppedCanvas({
        width: 300,
        height: 300,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      })
      const image = canvas.toDataURL('image/png', 0.92)

      this.avatarLoading = true
      try {
        const res = await uploadAvatar({ image })
        this.$store.commit('user/SET_USER_INFO', { ...this.userInfo, avatar: res.data.avatar })
        this.$message.success('头像上传成功')
        this.showAvatarDialog = false
      } finally {
        this.avatarLoading = false
      }
    },
    resetPwdForm() {
      this.$refs.pwdForm && this.$refs.pwdForm.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.user-card {
  .user-info-panel {
    text-align: center;
    padding: 10px 0;
    .avatar-area {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
    }
    .user-name {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      margin: 0 0 8px;
    }
    .user-email {
      font-size: 13px;
      color: #909399;
      margin: 0;
    }
    .user-detail {
      text-align: left;
      .detail-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 0;
        font-size: 13px;
        color: #606266;
        i { color: #409eff; }
        .label { color: #909399; }
      }
    }
  }
}
.text-muted { color: #c0c4cc; font-size: 13px; }

.cropper-wrap {
  display: flex;
  gap: 16px;

  .left {
    flex: 1;
  }
  .right {
    width: 180px;
    text-align: center;
    .preview-title {
      margin: 0 0 12px;
      color: #606266;
    }
    .tool-btns {
      margin-top: 12px;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      justify-content: center;
    }
  }
}

.cropper-box {
  margin-top: 12px;
  width: 100%;
  height: 360px;
  background: #f5f7fa;
  ::v-deep .cropper-container {
    width: 100% !important;
    height: 360px !important;
  }
}

.tip {
  margin-top: 12px;
  color: #909399;
  font-size: 12px;
}
</style>
